<!--案例前置学习题目及反馈内容部分-->
<template>
  <div class="precaseCom-layer">
    <!-- <div class="renwu">任务一：问题识别</div>
    <div class="duihua">
      <p>以下是模拟的用户咨询对话：</p>
      <p>学生用户：我的校园卡今天突然被扣了200元，但我没有进行任何消费！</p>
      <p>系统提示：请注意，后台监测显示近期已有10起类似投诉，疑似系统批量扣款错误</p>
    </div>
    <div class="zuoda">
      <p>作为智能客服，你首先需要：</p>
      <div class="answer" :class="activeIndex == 'A' ? 'actived' : ''" @click="activeIndex = 'A'">确认用户身份信息</div>
      <div class="answer" :class="activeIndex == 'B' ? 'actived' : ''" @click="activeIndex = 'B'">询问扣款的具体时间</div>
      <div class="answer" :class="activeIndex == 'C' ? 'actived' : ''" @click="activeIndex = 'C'">直接道歌并承诺退款</div>
    </div>
    <div class="fankui">
      <div class="fankuititle">反馈</div>
      <div class="fangkuitxt">
        错误
      </div>
    </div> -->
    <div class="renwu">{{ qianzhiData[activeNumber].taskname }}</div>
    <div class="duihua" v-html="qianzhiData[activeNumber].duihua"></div>
    <div class="zuoda">
      <p>{{ qianzhiData[activeNumber].zuoda }}</p>
      <div class="answer" :class="activeIndex == 'A' ? 'actived' : ''" @click="onChangeAnswer('A')">
        {{ qianzhiData[activeNumber].answerA }}
      </div>
      <div class="answer" :class="activeIndex == 'B' ? 'actived' : ''" @click="onChangeAnswer('B')">
        {{ qianzhiData[activeNumber].answerB }}
      </div>
      <div class="answer" :class="activeIndex == 'C' ? 'actived' : ''" @click="onChangeAnswer('C')">
        {{ qianzhiData[activeNumber].answerC }}
      </div>
    </div>
    <div class="fankui" v-show="activeIndex != '' && activeIndex !== qianzhiData[activeNumber].rightAnswer">
      <div class="fankuititle">反馈</div>
      <div class="fangkuitxt">
        错误
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    activeNumber () {
      return {
        type: Number,
        default: 0
      }
    },
    activeIndex: {
      type: String,
      default: ''
    },
    qianzhiData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // activeIndex: ''
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    //切换答案
    onChangeAnswer (answer) {
      this.activeIndex = answer
      console.log('正确答案：', this.qianzhiData[this.activeNumber].rightAnswer);

      if (this.activeIndex == this.qianzhiData[this.activeNumber].rightAnswer) {
        // this.$emit('onChangeAnswer', true)
        this.$emit('onChangeAnswer', {
          activeIndex: answer,
          isRight: true
        })
      } else {
        // this.$emit('onChangeAnswer', false)
        this.$emit('onChangeAnswer', {
          activeIndex: answer,
          isRight: false
        })
      }

    }
  }
}
</script>

<style scoped lang="less">
.precaseCom-layer {
  .renwu {
    margin: 0.1rem 0;
    font-size: 16px;
    color: #4568F7;
  }

  .duihua {}

  .zuoda {
    p {
      font-size: 16px;
    }

    .answer {
      cursor: pointer;
      background-color: #F5F5F5;
      padding: 0.1rem;
      margin: 0.1rem 0;

      &.actived {
        background-color: #4568F7;
        color: #fff;
      }
    }
  }

  .fankui {
    .fankuititle {
      margin: 0.1rem 0;
      font-size: 16px;
      color: #4568F7;
    }

    .fangkuitxt {
      color: red;
    }
  }
}
</style>
